import { create } from 'zustand';
import { Baby } from '../models';
import { storeService } from '../services/storeService';

interface BabiesStore {
  babies: Baby[];
  ownerId: number | null;
  loading: boolean;
  ensureLoaded: (customerId: number) => void;
  setBabies: (customerId: number, babies: Baby[]) => void;
  reset: () => void;
}

export const useBabiesStore = create<BabiesStore>()((set, get) => ({
  babies: [],
  ownerId: null,
  loading: false,

  ensureLoaded: (customerId) => {
    const { ownerId, loading } = get();
    if (ownerId === customerId || loading) return;
    set({ loading: true, babies: [], ownerId: null });
    storeService
      .getProfile()
      .then((profile) => {
        set({ babies: profile.babies ?? [], ownerId: customerId, loading: false });
      })
      .catch(() => set({ loading: false }));
  },

  setBabies: (customerId, babies) => set({ babies, ownerId: customerId, loading: false }),

  reset: () => set({ babies: [], ownerId: null, loading: false }),
}));
